// extracted by mini-css-extract-plugin
module.exports = {"heading":"AnchorHeading_heading__zxmy9","anchor":"AnchorHeading_anchor__0Qa1_"};